<div class="row no-gutters" [formGroup]="formGroup" *transloco="let t">
  <div class="form-group col-12">
    <label for="supportingMeasures">
      {{ t('child/supportingMeasure') }}
    </label>
    <ng-select
      id="supportingMeasures"
      formControlName="supportingMeasure"
      [items]="supportingMeasureOptions"
      bindLabel="longName"
      bindValue="id"
      [searchFn]="searchMeasurements"
      [placeholder]="t('child/select')"
      class="form-control"
      [virtualScroll]="true"
    >
      <ng-template ng-option-tmp let-item="item">
        <div class="d-flex justify-content-between">
          <div>{{ item.longName }}</div>
          <div class="code-measure">{{ item.code }}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>
  <div class="form-group col-12">
    <app-date-input
      [childForm]="formGroup"
      formControlName="start"
      [label]="t('child/supportingMeasuresStart')"
      [placeholder]="t('shared/selectDate')"
    >
    </app-date-input>
  </div>
  <div class="form-group col-12">
    <app-date-input
      [childForm]="formGroup"
      formControlName="end"
      [label]="t('child/supportingMeasuresEnd')"
      [placeholder]="t('shared/selectDate')"
    >
    </app-date-input>
  </div>
  <div class="form-group col-12">
    <label for="aidPurchaseForm">{{ t('child/aidPurchaseForm') }}</label>
    <ng-select
      id="aidPurchaseForm"
      formControlName="aidPurchaseForm"
      [items]="aidPurchaseForm"
      [placeholder]="t('child/select')"
      class="form-control"
    >
    </ng-select>
  </div>
  <div class="form-group col-12">
    <app-date-input
      [childForm]="formGroup"
      formControlName="actualProvisionStart"
      [label]="t('child/actualProvisionStart')"
      [placeholder]="t('shared/selectDate')"
    >
    </app-date-input>
  </div>
  <div class="form-group col-12">
    <app-date-input
      [childForm]="formGroup"
      formControlName="actualProvisionEnd"
      [label]="t('child/actualProvisionEnd')"
      [placeholder]="t('shared/selectDate')"
    >
    </app-date-input>
  </div>
  <div class="form-group col-12">
    <div class="d-flex margin-b-5">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="isFundingRequired" formControlName="isFundingRequired" />
        <label class="form-check-label" for="isFundingRequired">{{ t('child/isFundingRequired') }}</label>
      </div>
    </div>
  </div>
</div>
